import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useDynamicModule } from '@grandvisionhq/utils';

const AdyenContext = /*#__PURE__*/ React.createContext({
    clientKey: '',
    environment: 'test',
    merchantName: '',
    AdyenModule: {
        result: undefined,
        loading: true
    }
});
const useAdyen = ()=>React.useContext(AdyenContext)
;
const AdyenProvider = ({ children , settings  })=>{
    // The `@adyen/adyen-web` package uses a hard reference to the global `window` variable. This makes it
    // impossible to import the package in a normal manner. Hence the choice to use dynamic importing.
    const [result, loading] = useDynamicModule(swcHelpers.asyncToGenerator(function*() {
        if (typeof window !== 'undefined') {
            return yield import('@adyen/adyen-web').then((module)=>module.default
            );
        }
        return undefined;
    }), '@adyen/adyen-web', []);
    const memoizedSettings = React.useMemo(()=>swcHelpers.objectSpread({}, settings, {
            AdyenModule: {
                result: result !== null && result !== void 0 ? result : undefined,
                loading
            }
        })
    , [
        settings,
        loading,
        result
    ]);
    return /*#__PURE__*/ React.createElement(AdyenContext.Provider, {
        value: memoizedSettings
    }, children);
};

export { AdyenProvider, useAdyen };
//# sourceMappingURL=context.js.map
